import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdateLevelRequest from '../../../Spirit/Admin/Interfaces/Models/Level/UpdateLevelRequest';
import SearchLevelRequest from '../../../Spirit/Admin/Interfaces/Models/Level/SearchLevelRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import LevelResponse from '../../../Spirit/Admin/Interfaces/Models/Level/LevelResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';

export default class LevelService {
	webApiService: WebApiService;
	UpdateLevelEvent = new Events<WsResponseModelT<Boolean>>();
	GetLevelEvent = new Events<WsResponseModelT<LevelResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<LevelResponse>>>();
	DeleteLevelEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('LevelService', 'UpdateLevel', (res: WsResponseModelT<Boolean>) => {
			self.UpdateLevelEvent.trigger(res);
		});
		webApiService.on('LevelService', 'GetLevel', (res: WsResponseModelT<LevelResponse>) => {
			self.GetLevelEvent.trigger(res);
		});
		webApiService.on('LevelService', 'GetList', (res: WsResponseModelT<PaginationResponseT<LevelResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('LevelService', 'DeleteLevel', (res: WsResponseModelT<Boolean>) => {
			self.DeleteLevelEvent.trigger(res);
		});
	}
	UpdateLevel(request: UpdateLevelRequest = null) { 	
        this.webApiService.send('LevelService', 'UpdateLevel' , request);
    }
	GetLevel(levelId: number = 0) { 	
        this.webApiService.send('LevelService', 'GetLevel' , levelId);
    }
	GetList(request: SearchLevelRequest = null) { 	
        this.webApiService.send('LevelService', 'GetList' , request);
    }
	DeleteLevel(levelId: number = 0) { 	
        this.webApiService.send('LevelService', 'DeleteLevel' , levelId);
    }
	 // async methods
	async updateLevelAsync(request: UpdateLevelRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateLevel.bind(this), this.UpdateLevelEvent)(request);
	}
	async getLevelAsync(levelId: number = 0): Promise<LevelResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetLevel.bind(this), this.GetLevelEvent)(levelId);
	}
	async getListAsync(request: SearchLevelRequest = null): Promise<PaginationResponseT<LevelResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async deleteLevelAsync(levelId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteLevel.bind(this), this.DeleteLevelEvent)(levelId);
	}
}